import { render, staticRenderFns } from "./KjsBind.vue?vue&type=template&id=b278fee6&scoped=true&"
import script from "./KjsBind.vue?vue&type=script&lang=js&"
export * from "./KjsBind.vue?vue&type=script&lang=js&"
import style0 from "./KjsBind.vue?vue&type=style&index=0&id=b278fee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b278fee6",
  null
  
)

export default component.exports